import { Injectable, inject } from '@angular/core';
import { CoreHttpClient } from '@bepatient/core';
import { Observable, of } from 'rxjs';
import { TimelineApiService } from './timeline-api.service';
import { Timeline, TimelineInfoMessage } from './timeline.models';

/**
 * @ignore
 */
@Injectable()
export class TimelineApiApolloService implements TimelineApiService {
  private http = inject(CoreHttpClient);

  loadTimeline(): Observable<Timeline> {
    return this.http.get<any>('/api/timeline/v3');
  }

  infoMessageDone(_infoMessage: TimelineInfoMessage): Observable<any> {
    return of({});
  }

  saveForm(_formId: any, _data: any): Observable<any> {
    return of({});
  }
}
